import useTestId from '@ori/testid-generator';
import type { VFC } from 'react';

import { useRecurringPaymentCards } from '../hooks/useRecurringPaymentCards';

const componentName = 'card-number';

export const CardNumber: VFC = () => {
  const { getTestIdProps } = useTestId();
  const { data } = useRecurringPaymentCards();
  const cardNumber = data?.collection[0];

  if (!cardNumber) {
    return null;
  }

  const { cardNumberLast4, expiryMonth, expiryYear } = cardNumber;

  return (
    <div
      {...getTestIdProps(componentName)}
    >{`**** **** **** ${cardNumberLast4} ${expiryMonth}/${expiryYear}`}</div>
  );
};
